import React from "react"
import { Paper } from "@mui/material"
import Calendar from 'react-calendar'
import useEarnings from '../hooks/useEarnings'
import 'react-calendar/dist/Calendar.css'
import './EarningsCalendar.css'
import styles from '../../../pages/Dashboard.module.scss'

export default function EarningCalendar({setDaysEarnings, setEarningsDate, openEarningsModal, onlyWatchList}) {
  const lastDateOfCalendar = `12/31/${new Date().getFullYear()+2}`

  const firstDateOfCalendar = `01/01/${new Date().getFullYear()-2}`

  const {ifNeedUpdateEarnings, earnings, watchListEarnings, formatDate} = useEarnings()

  const getDaysEarnings = (date) => {
    const formattedDateString = `${date.toLocaleString('en-CA', { weekday: 'short'}).slice(0, -1)}, ${date.toLocaleString('en-CA', { month: 'long' })} ${date.getDate()}`
    setDaysEarnings(!onlyWatchList ? earnings[formatDate(date)] : watchListEarnings[formatDate(date)] )
    setEarningsDate(formattedDateString)
    openEarningsModal()
  }

  const renderTile = ({date}) => {
    const daysEarns = !onlyWatchList ? earnings[formatDate(date)] : watchListEarnings[formatDate(date)] !== undefined && [watchListEarnings[formatDate(date)]]
    const earnsAmounts = daysEarns?.length

    ifNeedUpdateEarnings(date) // checks if date is in data, if not - collects data back three months

    return (
        <div
          className={earnsAmounts > 0 ? 'day-tile--with-earnings' : ''}
          data-earnings={`${earnsAmounts} Earings`}
        />
    )
  }

  return (
    <Paper className={styles['earning-calendar-paper']}>
      <Calendar
        value={new Date()}
        tileContent={renderTile}
        minDetail='month'
        onClickDay={getDaysEarnings}
        maxDate={new Date(lastDateOfCalendar)}
        minDate={new Date(firstDateOfCalendar)}
      />
    </Paper>
  )
}